module.exports = __webpack_public_path__ + "static/media/Warning.30c5b440.svg";